/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: newRequestCtrl
* # alias: newReq
*/

export default class newRequestCtrl {

	constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, perfilSrv, $cookies, moment, 
		GlobalConfig, FileUploader, SERVICE_URL_CONSTANT, GlobalSrv) {
		var vm = this
 
		vm.$scope = $scope
		vm.$state = $state
		vm.$timeout = $timeout
		vm.ngNotify = ngNotify
		vm.$stateParams = $stateParams
		vm.services = perfilSrv
		vm.$cookies = $cookies
		vm.moment = moment
		vm.globalConfig = GlobalConfig
		vm.userinfo = null
		vm.$scope.show = 0
		vm.typeUpdate = ''
		vm.registersToUpdate = []
		vm.currentDate = new Date()
		vm.maxStartDate = moment(vm.currentDate).subtract(1, 'days').toDate()
		vm.messageFileType = false
		vm.messageFileSize = false
		vm.messageFileName = false
		vm.onlyRoles = []
		vm.academicsUnitAndRoles = []
		vm.exists = exists
		vm.rolesUnits = rolesUnits
		vm.unitsCombo = []
		vm.arrayUnit = []
		vm.$scope.personalDataAvaliable = false
		vm.personalForm = {}
		vm.typesOfFilesList = []
		vm.scopeOfTitleList = []
		vm.trajectoryTypeList = []
		vm.idRoles = GlobalConfig.roleAcUnitMapping

		let min = new Date()
	
		vm.urlService = null
		vm.isFileUploadFinish = false
		vm.auxServices = {
			2: vm.services.perfildocente.PerfildeInvestigacion,
			3: vm.services.perfildocente.perfilextention,
			4: vm.services.perfildocente.perfilFormacion,
			5: vm.services.perfildocente.TrayectoriaURGraph,
			6: vm.services.perfildocente.reconocimientoSeincentivos,
			7: vm.services.perfildocente.trayectoriaprevia
		}
		vm.serviceSave = {
			1: vm.services.post.savePersonalData,
			2: vm.services.post.saveInvestigationData,
			3: vm.services.post.saveExtensionData,
			4: vm.services.post.saveFormationData,
			5: vm.services.post.saveTrajectoryData,
			6: vm.services.post.saveRecognitionData,
			7: vm.services.post.savePrevTrajectoryData,
		
		}
		vm.countriesAndCities = []
		min = min.setFullYear(min.getFullYear() - 100)
		this.perfilTypes = {
			2: { type: '300', subType: '301' },
			3: { type: '205', indep: [ '206' ] },
			4: { type: '302', subType: '303' },
			5: { type: '309', subType: '310' },
			6: { type: '307', indep: [ '308' ] },
			7: { type: '322' },
		}
		vm.forms = {
			1: 
			{
				idHistActiv: null,
				name       : null,
				cedula     : null,
				address    : '',
				phone      : '',
				mail       : '',
				mail_alt   : '',
				nacionality: '',
				birthday   : null,
				maxDate    : vm.currentDate,
				minDate    : min,
				url_file   : '',
			}, 
			2: 
			{
				idHistActiv: null,
			}, 
			3: 
			{
				idHistActiv: null,
				myInit     : vm.maxStartDate, 
				myEnd      : vm.currentDate, 
				value      : null,
			},  
			4: 
			{
				idHistActiv      : null,	
				idTypTrayectory  : null,
				idLevel          : null,
				dsInstitution    : null,
				title            : null,
				dtActa           : null, 
				dtGrade          : vm.currentDate,
				city             : null,
				country          : null,
				nmActa           : null,
				level            : null,
				descriptionEq    : null,
				scopeOfTitle     : null,
				isMen            : null,
				isIssuedInSpanish: null,
			},  
			5: 
			{	
				idHistActiv  : null,
				idUnidad     : null,
				idRol        : null,
				dtInit       : vm.currentDate,
				dtEnd        : vm.currentDate,
				descriptionEq: null,
			},  
			6: 
			{
				idHistActiv: null,
				dtActa     : vm.currentDate,
				valueInc   : null,
				context    : 2,
			},
			7: 
			{
				idHistActiv: null,
				inst: null,
				charge: null,
				trajectoryType: null,
				dtInit     : vm.currentDate,
				dtEnd      : vm.currentDate,
			},
		}

		vm.id_wkf = {
			1: '3', // Datos personales
			2: '4', // Investigacion
			3: '4', // Extension
			4: '4', // Formacion
			5: '3', // Trayectoria UR
			6: '3', // Reconocimientos e Inc
			7: '3', //Trayectoria previa

		}
		vm.formId = {
			1: '1',
			2: '2',
			3: '3',
			4: '5',
			5: '6',
			6: '7',
			7: '4',

		}
		vm.typeRequest = [
			{ id_code: 1, ds_type: 'Nuevo' },
			{ id_code: 2, ds_type: 'Existente' },
		]
		vm.$scope.UserInfoConstant = UserInfoConstant
		perfilSrv.perfildocente.getUpdateForms().$promise.then((dataReturn) => {
			vm.avaliableForms = dataReturn.data
			for (let form in vm.avaliableForms) {
				vm.avaliableForms[form].value = false
			}
		
			vm.avaliableForms[6].value = true
		})
		vm.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
			if (details !== undefined) {
				vm.userinfo = details.user
				vm.userinfo.role_id = vm.$cookies.get('hasRoleId')
				vm.main()
			}
		})

		//methods
		vm.saveRequest	= saveRequest
		vm.onChangeAcademicUnit	= onChangeAcademicUnit
		vm.perfilToUpdate = perfilToUpdate
		vm.setRegArray = setRegArray
		vm.onChangeReg = onChangeReg
		vm.onChangeUpdateType = onChangeUpdateType
		vm.searchInstitution = searchInstitution
		vm.getTypePub = getTypePub
		vm.getDataForType = getDataForType
		vm.validateForm = validateForm
		vm.startDateChange = startDateChange
		vm.onChangeSelected = onChangeSelected
		vm.getService = getService
		vm.getCountriesAndCities = getCountriesAndCities
		vm.onChangeCountry = onChangeCountry
		vm.searchCities = searchCities
		vm.searchCountries = searchCountries
		vm.setForm = setForm
		vm.getIdFromSelected = getIdFromSelected
		vm.cleanForms = cleanForms
		vm.main = main
		vm.remove = remove
		vm.cleanValidation = cleanValidation
		vm.listData = listData
		vm.restartForms = restartForms

		//upload methods
		vm.$scope.uploader = new FileUploader({ url: SERVICE_URL_CONSTANT.rosario + '/perfil/uploadFileRequest' })

		// a sync filter
		vm.$scope.uploader.filters.push({
			name: 'syncFilter',
			fn  : function(item /*{File|FileLikeObject}*/, options) {
				return this.queue.length < 10
			},
		})

		// an async filter
		vm.$scope.uploader.filters.push({
			name: 'asyncFilter',
			fn  : function(item /*{File|FileLikeObject}*/, options, deferred) {
				setTimeout(deferred.resolve, 1e3)
			},
		})
		vm.$scope.uploader.filters.push({
			name: 'typeFilter',
			fn  :	function (item) {
    		if (/\/(pdf)$/.test(item.type)) {
					vm.messageFileType = false

					return true
				} else {
					vm.messageFileType = true
				}		
			},
		})

		vm.$scope.uploader.filters.push({
			name: 'sizeFilter',
			fn  : function (item) {
    		if (item.size <= 3145728) {
					vm.messageFileSize = false

					return true
				} else {
					vm.messageFileSize = true
				}
			},
		})
		vm.$scope.uploader.filters.push({
			name: 'nameFilter',
			fn  : function (item) {
				if (item.name.indexOf(' ') <= 0) {
					vm.messageFileName = false

					return true
				} else {
					vm.messageFileName = true
				}
			},
		})
		vm.$scope.uploader.onSuccessItem = function(fileItem, response, status, headers) {
			console.info('onSuccessItem', fileItem, response, status, headers)
		}
		vm.$scope.uploader.onErrorItem = function(fileItem, response, status, headers) {
			console.info('onErrorItem', fileItem, response, status, headers)
			vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
		}

		vm.$scope.uploader.onCompleteItem = function(fileItem, response, status, headers) {
			console.info('onCompleteItem', fileItem, response, status, headers)
		}

		vm.$scope.uploader.onBeforeUploadItem = function(item) {
			let header = {
				userId: vm.userinfo.id,
			}

			item.formData.push(header)
			$scope.loading = true
		}
		vm.$scope.uploader.onCompleteAll = function() {
			vm.$state.go('profile.Actualizacion_Perfil')
			vm.ngNotify.set('Perfil actualizado exitosamente!', 'success')
		}

		function remove(index) {
			vm.$scope.uploader.queue[index].remove()
		}
		function main() {
			vm.services.perfildocente.getperfil_dash({ teacherId: vm.userinfo.teacherId }).$promise.then((response) => {
				if (!response.status) {
					this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					let dataReturn = response.data[0]

					vm.personalForm.name = dataReturn.name
					vm.personalForm.cedula = dataReturn.identification_number
					vm.personalForm.address = dataReturn.address
					vm.personalForm.phone = dataReturn.phone_number
					vm.personalForm.mail = dataReturn.company_email
					vm.personalForm.mail_alt = dataReturn.altern_email
					vm.personalForm.nacionality = dataReturn.nationality
					vm.personalForm.birthday = new Date(dataReturn.birth_date)
					vm.forms[1].name = vm.personalForm.name
					vm.forms[1].cedula = vm.personalForm.cedula
					vm.forms[1].address = vm.personalForm.address
					vm.forms[1].phone = vm.personalForm.phone
					vm.forms[1].mail = vm.personalForm.mail
					vm.forms[1].mail_alt = vm.personalForm.mail_alt
					vm.forms[1].nacionality = vm.personalForm.nacionality
					vm.forms[1].birthday = vm.personalForm.birthday
				}

				vm.$scope.personalDataAvaliable = true
			}) 

			//INICIALIZADO EN EL FORMULARIO 4
			vm.perfilToUpdate(4) 

			vm.services.getInstitutionsSrv.getInstitutions().$promise.then((response) => {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					vm.institutions = response.data
				}
			}, (err) => {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
			vm.services.role.getInfo({ param1: vm.userinfo.id }).$promise.then((response) => {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					vm.userinfo.teacherId = response.data[0].idTeacher
					vm.services.perfildocente.getperfil_dash({ teacherId: vm.userinfo.teacherId }).$promise.then((response) => {
                	if (!response.status) {
                		vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
                	} else {
                		vm.identificationNumber = response.data[0].identification_number
                	}
					}, (err) => {
                	vm.ngNotify.set('Imposible conectar con el servicio', 'error')
					})
				}
			}, (err) => {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}
	
		function searchInstitution(institutionTerm) {
			let matcher = new RegExp(institutionTerm, 'gi')
			let arr = []

			vm.institutions.forEach((institution) => {
				if (institution['name'].match(matcher)) {
					arr.push(institution)
				}
			})

			return arr
		}
	
		function searchCountries(countryTerm) {
			let matcher = new RegExp(countryTerm, 'gi')
			let arr = []

			vm.countriesAndCities.forEach((country) => {
				if (country['ds_pais'].match(matcher)) {
					arr.push(country)
				}
			})

			return arr
		}
	
		function searchCities(cityTerm) {
			let matcher = new RegExp(cityTerm, 'gi')
			let arr = []

			vm.cities.forEach((city) => {
				if (city['ds_ciudad'].match(matcher)) {
					arr.push(city)
				}
			})

			return arr
		}

		function getDataForType(typeId, callback) {
			return vm.services.list.getListItems({ param1: typeId }).$promise.then((response) => {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					callback(response.data)
				}
			}, (err) => {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}
	
		function getTypePub(param, callback) {
			return this.services.list.getListItems({ param1: param }).$promise.then((response) => {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					callback(response.data)
				}
			}, (err) => {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}

		function onChangeUpdateType(type) {
			if (type == 2 && vm.$scope.show != 0) {
				vm.perfilToUpdate(vm.$scope.show)

				if (this.$scope.show == 1) {
					vm.forms[1].address = vm.personalForm.address
					vm.forms[1].phone = vm.personalForm.phone
					vm.forms[1].mail = vm.personalForm.mail
					vm.forms[1].mail_alt = vm.personalForm.mail_alt
					vm.forms[1].nacionality = vm.personalForm.nacionality
					vm.forms[1].birthday = vm.personalForm.birthday	
				}
			}

			if (type == 1 && vm.$scope.show != 0) {
				vm.cleanForms()

				if (this.$scope.show == 1) {
					vm.forms[1].name = vm.personalForm.name
					vm.forms[1].cedula = vm.personalForm.cedula
					vm.forms[1].birthday = vm.personalForm.birthday
				} else if (this.$scope.show == 6) {
					this.restartForms(6)
				}
			}
		}

		function onChangeReg(item) {
			if (item !== undefined) {
				for (let i in item.original) {
					var val = (item.original[i] != null) ? item.original[i].toString() : item.original[i]

					vm.forms[vm.$scope.show][i] = (val != null && val.match(/00Z/g)) ? new Date(val.substring(0, 19)) : val 
				}
				this.setForm()
			} else {
				vm.cleanForms()
			}

			vm.forms[vm.$scope.show].url_file = ''
		}

		function setForm() {
			if (vm.$scope.show == 2) {
				vm.forms[vm.$scope.show].nmPublishYear = +vm.forms[vm.$scope.show].anoDePublicacion
				vm.forms[vm.$scope.show].title = vm.forms[vm.$scope.show].titulo
				vm.forms[vm.$scope.show].idPublishType = vm.getIdFromSelected(vm.forms[vm.$scope.show].tipoDePublicacion, 'listItemName', 'idListItem', vm.comboBoxTypePub)
				vm.forms[vm.$scope.show].idPublishSubType = vm.getIdFromSelected(vm.forms[vm.$scope.show].subTipo, 'listItemName', 'idListItem', vm.comboBoxSubTypePub)
			}


			if (vm.$scope.show == 3) {
				vm.forms[vm.$scope.show].service = vm.forms[vm.$scope.show].servico
				vm.forms[vm.$scope.show].totitle = vm.forms[vm.$scope.show].aTitulo
				vm.forms[vm.$scope.show].myInit = vm.forms[vm.$scope.show].mesAnoInicio
				vm.forms[vm.$scope.show].myEnd = vm.forms[vm.$scope.show].mesAnoFinalizacion
				vm.forms[vm.$scope.show].nameEntity = vm.forms[vm.$scope.show].entContratante
				vm.forms[vm.$scope.show].result = vm.forms[vm.$scope.show].resultados
				vm.forms[vm.$scope.show].scope = ''
				vm.forms[vm.$scope.show].typeEntity = vm.getIdFromSelected(vm.forms[vm.$scope.show].tipoDeEntidad, 'listItemName', 'idListItem', vm.comboBoxTypeInde)
			}

			if (vm.$scope.show == 4) {
				vm.forms[vm.$scope.show].idTypTrayectory = vm.getIdFromSelected(vm.forms[vm.$scope.show].type, 'listItemName', 'idListItem', vm.comboBoxTypePub)			
				vm.onChangeSelected(vm.$scope.show, vm.forms[vm.$scope.show].idTypTrayectory, function () {
					vm.forms[vm.$scope.show].idLevel = vm.getIdFromSelected(vm.forms[vm.$scope.show].ds_formation_level, 'listItemName', 'idListItem', vm.comboBoxSubTypePub)			
				})
				vm.forms[vm.$scope.show].dsInstitution = vm.forms[vm.$scope.show].university
				vm.forms[vm.$scope.show].title = vm.forms[vm.$scope.show].program_name
				vm.forms[vm.$scope.show].dtGrade = (vm.forms[vm.$scope.show].end_date) ? new Date(vm.forms[vm.$scope.show].end_date) : null
				vm.forms[vm.$scope.show].isMen = vm.forms[vm.$scope.show].isMen ? true : false
				vm.forms[vm.$scope.show].isIssuedInSpanish = vm.forms[vm.$scope.show].isIssuedInSpanish ? true : false
				vm.forms[vm.$scope.show].scopeOfTitle = vm.getIdFromSelected(vm.forms[vm.$scope.show].scopeOfTitle, 'listItemName', 'idListItem', vm.scopeOfTitleList)
			}

			if (vm.$scope.show == 5) {
				vm.forms[vm.$scope.show].idUnidad = vm.getIdFromSelected(vm.forms[vm.$scope.show].dsUnidad, 'academitUnitName', 'academitUnitId', vm.arrayUnit)
				vm.rolesUnits(vm.forms[vm.$scope.show].idUnidad, function () {
					vm.forms[vm.$scope.show].idRol = vm.getIdFromSelected(vm.forms[vm.$scope.show].dsRol, 'roleName', 'roleId', vm.rolesCombo)			
				})
				vm.forms[vm.$scope.show].dtInit = vm.forms[vm.$scope.show].dtInitAll
				vm.forms[vm.$scope.show].dtEnd = vm.forms[vm.$scope.show].dtEndAll
				vm.forms[vm.$scope.show].descriptionEq = vm.forms[vm.$scope.show].designation
			}

			if (vm.$scope.show == 6) {
				vm.forms[vm.$scope.show].typeRI = vm.getIdFromSelected(vm.forms[vm.$scope.show].ack_type, 'listItemName', 'idListItem', vm.comboBoxTypePub)
				vm.forms[vm.$scope.show].dtActa = (vm.forms[vm.$scope.show].date_ceremony) ? new Date(vm.forms[vm.$scope.show].date_ceremony) : null
				vm.forms[vm.$scope.show].name = vm.forms[vm.$scope.show].ack_acknowledgment
				vm.forms[vm.$scope.show].description = vm.forms[vm.$scope.show].academic_unit
				vm.forms[vm.$scope.show].scope = vm.getIdFromSelected(vm.forms[vm.$scope.show].ambit, 'listItemName', 'idListItem', vm.comboBoxTypeInde)
			}

			if (vm.$scope.show == 7) {
				vm.forms[vm.$scope.show].inst = vm.forms[vm.$scope.show].Institucion
				vm.forms[vm.$scope.show].dtInit = vm.forms[vm.$scope.show].AnoInicio ? moment(vm.forms[vm.$scope.show].AnoInicio,  "DD/MM/YYYY").toDate(): ''
				vm.forms[vm.$scope.show].dtEnd = vm.forms[vm.$scope.show].AnoFin ? moment(vm.forms[vm.$scope.show].AnoFin,  "DD/MM/YYYY").toDate(): ''
				vm.forms[vm.$scope.show].charge = vm.forms[vm.$scope.show].Cargo
				vm.forms[vm.$scope.show].trajectoryType = vm.getIdFromSelected(vm.forms[vm.$scope.show].type, 'listItemName', 'idListItem', vm.comboBoxTypePub)	
			}
		}

		function cleanForms() {
			for (let x in vm.forms[vm.$scope.show]) {
				vm.forms[vm.$scope.show][x] = null
			}
		}

		function getIdFromSelected(find, field, toReturn, data) {
			let val = ''
			let toFind = ''

			if (find != null) {
				for (let i in data) {
					val = data[i][field].toLowerCase().replace(/í/gi, 'i').replace(/ó/gi, 'o')
					toFind = find.toLowerCase().replace(/í/gi, 'i').replace(/ó/gi, 'o')

					if (val == toFind) {
						return data[i][toReturn].toString()
					}
				}
			}
		}
	
		function setRegArray(data) {
			vm.registersToUpdate = []
			
			for (let [index, item] of data.entries()) {
				vm.registersToUpdate.push({
					id_code   : index,
					ds_name   : item.designation || item.Titulo || item.title || item.university || item.ack_acknowledgment || item.campoDescripcion || item.tipoDePublicacion || item.Cargo ,
					ds_descrip: item.Unidad || item.Subtipo || item.subtipo || item.descripction || item.program_name || item.ack_acknowledgement_category || item.objeto || item.subtipo || item.Institucion,
					original  : item,
				})
			}
		}

		function onChangeSelected(perfilId, idType, callback) {
			let params = { param1: this.perfilTypes[perfilId].subType, param2: idType }

			this.comboBoxSubTypePub = []
			let service = this.getService()

			service(params).$promise.then((response) => {
				if (!response.status) {
					this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					this.comboBoxSubTypePub = response.data

					if (typeof callback != 'undefined') {
						callback()
					}
				}
			}, (err) => {
				this.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}

		function getService() {
			if (vm.$scope.show == 4 || vm.$scope.show == 2)
				return this.services.list.getListItemsSubtype
		}

		function startDateChange(form) {
			let fieldInit = form == 3 ? 'myInit' : 'dtInit'
			let fieldFinal = form == 3 ? 'myEnd' : 'dtEnd'
			let mInit = moment(vm.forms[form][fieldInit])
			let mEnd = moment(vm.forms[form][fieldFinal])

			if (mInit.isAfter(mEnd) || mInit.isSame(mEnd)) {
				vm.forms[form][fieldInit] = mEnd.isValid() ? mEnd.subtract(1, 'days').toDate() : null
			}
		}

		function validateForm(form) {
		// validata que almenos uno de las opciones de alcance de emisión de titulo este seleccionada
			if (vm.forms['4'].scopeOfTitle == 1069 && vm.forms['4'].isMen == 0 && vm.forms['4'].isIssuedInSpanish == 0) {
				return true
			}

      	return form.$invalid
		}

		function exists(field, value, array) {
    	for (var index in array) {
    		if (array[index][field] == value) {
    			return true
    		} 
    	}

    	return false
		}

		function rolesUnits(value, callback) {
    	vm.rolesCombo = []
    	for (var index in vm.unitsAndRolesCombo) {
    		if (vm.unitsAndRolesCombo[index].academitUnitId == value) {
    			var temp = {
    				roleId  : vm.unitsAndRolesCombo[index].roleId,
    				roleName: vm.unitsAndRolesCombo[index].roleName,
    			}

    			vm.rolesCombo.push(temp)
    		}
    	}

    	if (typeof callback != 'undefined') {
    		callback()
    	}
		}

		function listData () {
			if (vm.typesOfFilesList.length && vm.scopeOfTitleList.length) return

			vm.getDataForType(323, (response) => {
				vm.typesOfFilesList = response
			})
			vm.getDataForType(308, (response) => {
				vm.scopeOfTitleList = response
			})
		}

		function restartForms(id) {
			if (id == 6) {
				vm.forms[6].context = 2
				vm.forms[6].dtActa = vm.currentDate
			}
		}

		function perfilToUpdate(id) {
			vm.$scope.show = id
			vm.registersToUpdate = []
			vm.comboBoxSubTypePub = []
			vm.cleanForms()
			vm.regUpdate = null
	
			if (this.$scope.show != 1 && this.$scope.show != 5) {
				this.getDataForType(this.perfilTypes[id].type, (data) => {
					vm.comboBoxTypePub = data
				})

				if (this.perfilTypes[id].indep !== undefined) {
					for (let i in this.perfilTypes[id].indep) {
						this.getDataForType(this.perfilTypes[id].indep[i], (data) => {
							if (i == 0) {
								vm.comboBoxTypeInde = data
							} else {
								vm.comboBoxTypeInde2 = data
							}
						})
					}
				}
			}

			vm.forms['5'].city = null

			if (this.$scope.show == 4) {
				vm.listData()
				vm.getCountriesAndCities()
			}

			if (this.$scope.show == 5) {
				let params = {
					workplanId: 0,
					teacherId : 0, 
				}

				vm.services.post.getUndAcademicAndRole(params).$promise.then((dataReturn) => {
					if (dataReturn.status) {
			          vm.typePeriod = dataReturn.workplanperiod
			          vm.unitsAndRolesCombo = dataReturn.rolesacademicunits
			          vm.unitsCombo = dataReturn.rolesacademicunits
			          //////////////crear un array solo para la unidad//////////////
			          for (var index in vm.unitsCombo) {
			            if (!vm.exists('academitUnitId', vm.unitsCombo[index].academitUnitId, vm.arrayUnit)) {
			              var temp = {
			                academitUnitId  : vm.unitsCombo[index].academitUnitId,
			                academitUnitName: vm.unitsCombo[index].academitUnitName,
			              }

			              vm.arrayUnit.push(temp)
			            }
			          }
			          /////////////////////fin//////////////
			        }
				}, (err) => {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error')
				})
			} else if (this.$scope.show == 1) {
				if (vm.typeUpdate == 2) {
					vm.forms[1].name = vm.personalForm.name
					vm.forms[1].cedula = vm.personalForm.cedula
					vm.forms[1].address = vm.personalForm.address
					vm.forms[1].phone = vm.personalForm.phone
					vm.forms[1].mail = vm.personalForm.mail
					vm.forms[1].mail_alt = vm.personalForm.mail_alt
					vm.forms[1].nacionality = vm.personalForm.nacionality
					vm.forms[1].birthday = vm.personalForm.birthday
				} else {
					vm.forms[1].name = vm.personalForm.name
					vm.forms[1].cedula = vm.personalForm.cedula
				}	
			} else if (this.$scope.show == 7) {
				let params = {
					workplanId: 0,
					teacherId : 0, 
				}

				vm.services.list.listTypeTrayect(params).$promise.then((dataReturn) => {
					if (dataReturn.status) {
			          vm.typePeriod = dataReturn.workplanperiod
			          vm.unitsAndRolesCombo = dataReturn.rolesacademicunits
			          vm.unitsCombo = dataReturn.rolesacademicunits
			          //////////////crear un array solo para la unidad//////////////
			          for (var index in vm.unitsCombo) {
			            if (!vm.exists('academitUnitId', vm.unitsCombo[index].academitUnitId, vm.arrayUnit)) {
			              var temp = {
			                academitUnitId  : vm.unitsCombo[index].academitUnitId,
			                academitUnitName: vm.unitsCombo[index].academitUnitName,
			              }

			              vm.arrayUnit.push(temp)
			            }
			          }
			          /////////////////////fin//////////////
			        }
				}, (err) => {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error')
				})
			}

			if ((vm.$scope.show != 0 && vm.$scope.show != 1) && vm.typeUpdate == 2) {			
				const context = vm.$scope.show == 6 ? 2 : null // Context:2 -> reconocimientos e incentivos

				vm.auxServices[vm.$scope.show]({ teacherId: vm.userinfo.teacherId, context }).$promise.then((response) => {
					if (!response.status) {
						return vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
					} 
					vm.setRegArray(response.data)
				}, (err) => {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error')
				})
			}
		}

		function onChangeAcademicUnit(acadUnit) {
			vm.onlyRoles = []
			vm.forms['5'].idRol = ''
			for (let i in vm.academicsUnitAndRoles) {
				if (vm.academicsUnitAndRoles[i].academitUnitId == acadUnit) {
					vm.onlyRoles.push(vm.academicsUnitAndRoles[i])
				}
			}
		}

		function onChangeCountry(country) {
			vm.cities = []
			vm.forms['5'].city = null
			for (let i in vm.allCountries) {
				if (vm.allCountries[i].id_pais == country) {
					vm.cities.push(vm.allCountries[i])
				}
			}
		}

		function getCountriesAndCities() {
			vm.countriesAndCities = []
			this.services.list.getCountriesAndCities().$promise.then((response) => {
				if (!response.status) {
					return this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} 

				vm.allCountries = response.data

				for (let i in response.data) {
					if (!vm.exists('id_pais', response.data[i].id_pais, this.countriesAndCities)) {
						vm.countriesAndCities.push(response.data[i])
					}
				}
			}, (err) => {
				this.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}

		function cleanValidation() {
			vm.forms[4].isMen = 0
			vm.forms[4].isIssuedInSpanish = 0
		}

		function getNotify(idRole) {
			let usersByRol = []
			let header = { rolId: idRole }

			GlobalSrv.getUserByRol.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status == true) {
					usersByRol = dataReturn.data

					for (var i in usersByRol) {
						getSendNotify(usersByRol[i].id_user)
					}
				} else {
					console.log('Ocurrio un error en el servicio de notificación')
				}
			}, function(dataReturn) {
				console.log(dataReturn)
			})
		}
    
		function getSendNotify(idUser) {
			let data = {
				idUser                      : idUser,
				dsName                      : 'Notificación de solicitud a pendiente de revisión',
				dsDescription               : 'Ha recibido una solicitud de actualización de información del profesor "' + JSON.parse(vm.$cookies.get('currentUser')).dsFullname + '".',
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
				is_grouped                  : 1,
			}

			GlobalSrv.sendNotification(data)
		}

		function saveRequest() {
			const requiredValidationOfFiles = (update) => {
				// Perfil existente
				const isAProfileUpdate = (this.$scope.show == 1)

				if(isAProfileUpdate) return false

				return true
			}


			if (vm.$scope.show != 0 && vm.typeUpdate != '') {
				vm.noFile = false
				vm.hasErrors = false
				$scope.savingForm = true
				$scope.errorMessage = ''
				let update = vm.forms[vm.$scope.show]

				const form = vm.avaliableForms.filter(form => vm.formId[form.id_code] == vm.$scope.show)	
				
				update.id_wkf = form[0].id_workflow
				update.teacherId = vm.userinfo.teacherId
				update.type = vm.typeUpdate
				update.userid = vm.userinfo.id
				update.fileNames = []

				if (update.id_wkf === 3)
					update.stageId = vm.globalConfig.initStageUpdate.wfCorto
				else
					update.stageId = vm.globalConfig.initStageUpdate.wfLargo

				for (var i = 0 ; i < vm.$scope.uploader.queue.length; i++) {
					update.fileNames.push({ name: vm.$scope.uploader.queue[i].file.name, typeOfFile: vm.$scope.uploader.queue[i].typeOfFile })
				}

				if (update.fileNames.length <= 0 && requiredValidationOfFiles(update)) {
					vm.noFile = true
					$scope.errorMessage = 'No se ha adjuntado ningun archivo'
					$scope.savingForm = false

					return
				}

				if (vm.$scope.show == vm.globalConfig.orderProfiles.perfil_formacion) {
					if (update.dsInstitution) {
						update.dsInstitution = update.dsInstitution.name || update.dsInstitution
					} else if (update.dsInstitutionSearch) {
						update.dsInstitution = update.dsInstitutionSearch
					} else {
						$scope.errorMessage = 'Debe ingresar el nombre de la institución'
						vm.hasErrors = true
						$scope.savingForm = false

						return
					}

					if (update.country !== null) {
						update.country = update.country.ds_pais || update.country
					}

					if (update.city !== null) {
						update.city = update.city.ds_ciudad || update.city
					}
				}

				if (typeof update.idHistActiv === 'undefined')
					update.idHistActiv = null

				if (typeof update.idUnidad === 'undefined')
					update.idUnidad = null

				if (typeof update.idRol === 'undefined')
					update.idRol = vm.userinfo.role_id

				vm.serviceSave[vm.$scope.show](update).$promise.then((response) => {
					if (!response.status) {
						$scope.savingForm = false
						vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
					} else {
  					getNotify(GlobalConfig.userRolesIds.reviewerUpdatePerfil) //Dir. Académica

						vm.logIdInsert = response.data[1]

						if (vm.$scope.uploader.queue.length > 0) {
							for (var i = 0 ; i < vm.$scope.uploader.queue.length; i++) {
								vm.$scope.uploader.queue[i].url = vm.$scope.uploader.url + '?userId=' + vm.identificationNumber + '&requestId=' + response.data[0] + '&logId=' + vm.logIdInsert
							}
							vm.$scope.uploader.uploadAll()
						} else {
							$scope.savingForm = false
							vm.$state.go('profile.Actualizacion_Perfil')
							vm.ngNotify.set('Perfil actualizado exitosamente!', 'success')
						}
					}
				}, (err) => {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error')
				})
			}
		}
	}

}

newRequestCtrl.$inject = [ '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'perfilSrv', '$cookies', 'moment',
	'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT', 'GlobalSrv' ]


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/Actualizacion_Perfil/newRequestCtrl.js